export default "__VITE_ASSET__xYTJd31cnZPTzpy3_4yQcA__";